module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-5_inactive-d4572e01df05865c423038bb82f60261.svg";